import React, { useEffect, useState } from "react";
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme } from "@mui/material";
import moment from 'moment-timezone';


function HeaderProductionTracking(props) {
    const today = new Date();
    const hourago = new Date(today.getTime());
    const timestr = moment(hourago).tz('Asia/Bangkok').format('DD MMM YY');
    const timestrs = moment(hourago).tz('Asia/Bangkok').format('HH:mm:ss');

    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Grid container spacing={2}>
            <Grid item xs={2} style={{ backgroundColor: "#2e9281"}} textAlign="center" >
                <Typography
                    style={{ color: "#ffffff", fontWeight: "bold", fontSize: 25 }}
                >
                    {props.line}
                </Typography>
            </Grid>
            <Grid item xs={1.2} textAlign="left" >
                <Typography
                    style={{ color: "#ffffff", fontWeight: "bold", fontSize: 25, position: "relative", left: "-1vw" }}
                >
                    SKU :
                </Typography>
            </Grid>
            <Grid item xs={2.8} textAlign="left">
                <Typography
                    style={{ color: "#4AC6B1", fontWeight: "bold", fontSize: 25, position: "relative", left: "-2.2vw" }}
                >
                    {props.sku}
                </Typography>
            </Grid>
            <Grid item xs={5} textAlign="right">
                <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <Typography
                        style={{ color: "#ffffff", fontWeight: "bold", fontSize: 25 }}
                        textAlign="right"
                    >
                        {props.day}&nbsp;&nbsp;{time.toLocaleTimeString('en-GB')}
                    </Typography>

                </Box>
            </Grid>
            <Grid item xs={1} textAlign="left">
                <Typography
                    style={{ position: "relative", paddingTop: 5 }}
                >
                    {props.icon}
                </Typography>
            </Grid>

        </Grid>

    );
}

export default HeaderProductionTracking